import type { ShortcutIcon } from "./shortcuts";

/**
 * Raccourcis vers une fiche précise, épinglée depuis son en-tête. Le type est
 * le segment d'URL des fiches d'édition (`/edit/<type>/<id>`).
 */
export const RECORD_SHORTCUT_TYPES = [
  "artwork",
  "multipleprint",
  "collector",
  "exhibition",
  "bibliography",
  "auction",
  "author",
  "writing",
  "photography",
  "document",
  "audiovisual",
] as const;

export type RecordShortcutType = (typeof RECORD_SHORTCUT_TYPES)[number];

export type RecordShortcut = {
  type: RecordShortcutType;
  id: string;
  label: string;
};

export const RECORD_SHORTCUT_ICONS: Record<RecordShortcutType, ShortcutIcon> = {
  artwork: "palette",
  multipleprint: "layers",
  collector: "user",
  exhibition: "landmark",
  bibliography: "book",
  auction: "gavel",
  author: "user",
  writing: "pen-line",
  photography: "camera",
  document: "file-text",
  audiovisual: "film",
};

export function isRecordShortcutType(
  value: unknown,
): value is RecordShortcutType {
  return (RECORD_SHORTCUT_TYPES as readonly unknown[]).includes(value);
}

/** Id stable : une fiche ne peut être épinglée qu'une fois. */
export function recordShortcutId(type: RecordShortcutType, id: string): string {
  return `record:${type}:${id}`;
}

export function recordShortcutPath({
  type,
  id,
}: Pick<RecordShortcut, "type" | "id">): string {
  return `/edit/${type}/${encodeURIComponent(id)}`;
}
